import React from 'react';
import { InternalAuditorTemplate } from '../components/training/templates/InternalAuditorTemplate';
import { getStandardBySlug } from '../data/standards/standardsData';
import { getInternalAuditorContent } from '../data/standards/trainingContent';

export const ISO22000InternalAuditor = () => {
  const standard = getStandardBySlug('iso-22000');
  const content = getInternalAuditorContent('iso-22000');

  return <InternalAuditorTemplate standard={standard} content={content} />;
};
